import { Service } from "typedi";
import { AgentRPCCommand } from "../../../../shared/RPC/AgentRPCCommand";
import { AgentRPCCommands } from "../../../../shared/RPC/AgentRPCCommands";
import { AnnouncementState } from "../state/AnnouncementState";
import { ControllerBroadcaster } from "../ControllerBroadcaster";

@Service()
export class Announce implements AgentRPCCommand<"announce"> {
    constructor(
        agentRPCCommands: AgentRPCCommands,
        private readonly announcementState: AnnouncementState,
        private readonly broadcaster: ControllerBroadcaster
    ) {
        agentRPCCommands.register("announce", this);
    }

    async run(message: string): Promise<void> {
        const data = this.announcementState.announce(message);
        this.broadcaster.broadcastToContentScripts({ kind: "show-announcement", data });
    }
}
